exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".scrollWrapper-d1fa8661{max-height:205px;overflow:auto}.table-49f2e0b0{z-index:0;font-weight:normal;position:relative;width:calc(100% - 30px);table-layout:fixed;border-collapse:collapse;margin:0 15px}.table-49f2e0b0 td{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.table-49f2e0b0 tr td:first-child,.table-49f2e0b0 tr th:first-child{padding-left:10px}.table-49f2e0b0 tr td:last-child,.table-49f2e0b0 tr th:last-child{padding-right:10px}.fixedHeading-283dfbe9{position:absolute;background:#FFF;z-index:1}.heading-6cdfe04f{font-weight:bold}.heading-6cdfe04f tr{border-bottom:1px dotted #cfcfcf}.heading-6cdfe04f th{text-align:left}.body-21d4b98d{max-height:205px;overflow-y:scroll}a.tName-cb8a0087:hover{text-decoration:underline}.thName-5fa5d7b0{width:30%}.thExclude-4149e177{width:70px}.loadMore-0f5d8d22{text-align:center}.excluded-ecc2c805{text-decoration:line-through}\n", ""]);

// Exports
exports.locals = {
	"scrollWrapper": "scrollWrapper-d1fa8661",
	"table": "table-49f2e0b0",
	"fixedHeading": "fixedHeading-283dfbe9",
	"heading": "heading-6cdfe04f",
	"body": "body-21d4b98d",
	"tName": "tName-cb8a0087",
	"thName": "thName-5fa5d7b0",
	"thExclude": "thExclude-4149e177",
	"loadMore": "loadMore-0f5d8d22",
	"excluded": "excluded-ecc2c805"
};